var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesFill = function SvgResourcesFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    d: "M12.024 36H42V8a4 4 0 0 0-4-4H12c-2.412 0-6 1.598-6 6v28c0 4.402 3.588 6 6 6h30v-4H12.024C11.1 39.976 10 39.61 10 38s1.1-1.976 2.024-2M16 12h18v4H16z"
  })));
};
export { SvgResourcesFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjAyNCAzNkg0MlY4QzQyIDYuOTM5MTMgNDEuNTc4NiA1LjkyMTcyIDQwLjgyODQgNS4xNzE1N0M0MC4wNzgzIDQuNDIxNDMgMzkuMDYwOSA0IDM4IDRIMTJDOS41ODggNCA2IDUuNTk4IDYgMTBWMzhDNiA0Mi40MDIgOS41ODggNDQgMTIgNDRINDJWNDBIMTIuMDI0QzExLjEgMzkuOTc2IDEwIDM5LjYxIDEwIDM4QzEwIDM2LjM5IDExLjEgMzYuMDI0IDEyLjAyNCAzNlpNMTYgMTJIMzRWMTZIMTZWMTJaIiBmaWxsPSIjMjgzRTRDIi8+Cjwvc3ZnPgo=";